import { WithStatusCU as imported872_WithStatusCU, WithStatusU as imported442_WithStatusU, WithIdC as imported292_WithIdC, WithStatusCU as imported880_WithStatusCU, WithStatusCU as imported889_WithStatusCU, WithModInfo as imported258_WithModInfo, WithIdC as imported293_WithIdC, WithStatusCU as imported890_WithStatusCU, WithStatusU as imported436_WithStatusU, WithStatusCU as imported887_WithStatusCU, withIdC as imported293_withIdC, WithStatusU as imported439_WithStatusU, WithStatusU as imported435_WithStatusU, WithStatusCU as imported881_WithStatusCU, withModInfoC as imported257_withModInfoC, WithModInfoC as imported256_WithModInfoC, WithModInfoC as imported257_WithModInfoC, withIdC as imported292_withIdC, WithStatusU as imported440_WithStatusU, WithModInfoC as imported254_WithModInfoC, WithStatusU as imported441_WithStatusU, WithModInfoC as imported259_WithModInfoC, WithId as imported293_WithId, WithModInfo as imported257_WithModInfo, WithStatusCU as imported884_WithStatusCU, WithModInfoC as imported255_WithModInfoC, WithModInfoC as imported253_WithModInfoC, WithStatusCU as imported888_WithStatusCU, withModInfoC as imported255_withModInfoC, WithStatusCU as imported868_WithStatusCU, WithStatusCU as imported891_WithStatusCU, WithStatusCU as imported883_WithStatusCU, WithStatusCU as imported874_WithStatusCU, WithStatusU as imported434_WithStatusU, WithId as imported292_WithId, WithModInfoC as imported258_WithModInfoC, WithStatusCU as imported878_WithStatusCU, withModInfoC as imported258_withModInfoC, WithModInfo as imported253_WithModInfo, withModInfoC as imported256_withModInfoC, WithStatusCU as imported869_WithStatusCU, WithStatusCU as imported882_WithStatusCU, WithModInfo as imported256_WithModInfo, WithModInfo as imported259_WithModInfo, withModInfoC as imported253_withModInfoC, WithModInfo as imported254_WithModInfo, WithStatusCU as imported876_WithStatusCU, WithStatusU as imported437_WithStatusU, WithStatusU as imported443_WithStatusU, WithStatusCU as imported871_WithStatusCU, WithStatusCU as imported873_WithStatusCU, WithStatusCU as imported885_WithStatusCU, WithStatusCU as imported877_WithStatusCU, withModInfoC as imported254_withModInfoC, WithModInfo as imported255_WithModInfo, WithStatusCU as imported886_WithStatusCU, WithStatusCU as imported875_WithStatusCU, withModInfoC as imported259_withModInfoC, WithStatusCU as imported870_WithStatusCU, WithStatusU as imported438_WithStatusU, WithStatusU as imported444_WithStatusU, WithStatusU as imported445_WithStatusU, WithStatusCU as imported879_WithStatusCU } from "./threadThrough";
import * as t from "io-ts";
import { Ord as stringOrd } from "fp-ts/lib/string";
import { LocalDateC } from "../../codecs/localDate";
import { taggedContentC as imported228_taggedContentC, TaggedContent as imported228_TaggedContent, TaggedContent as imported235_TaggedContent, taggedContentC as imported224_taggedContentC, TaggedContent as imported224_TaggedContent, taggedContentC as imported232_taggedContentC, taggedContentC as imported229_taggedContentC, TaggedContent as imported226_TaggedContent, taggedContentC as imported227_taggedContentC, TaggedContentC as imported228_TaggedContentC, TaggedContentC as imported231_TaggedContentC, taggedContentC as imported230_taggedContentC, TaggedContentC as imported235_TaggedContentC, TaggedContent as imported233_TaggedContent, TaggedContentC as imported232_TaggedContentC, TaggedContentC as imported224_TaggedContentC, TaggedContent as imported225_TaggedContent, TaggedContentC as imported233_TaggedContentC, TaggedContentC as imported226_TaggedContentC, TaggedContentC as imported225_TaggedContentC, taggedContentC as imported225_taggedContentC, TaggedContentC as imported227_TaggedContentC, TaggedContentC as imported230_TaggedContentC, taggedContentC as imported234_taggedContentC, TaggedContentC as imported229_TaggedContentC, TaggedContentC as imported234_TaggedContentC, taggedContentC as imported231_taggedContentC, TaggedContent as imported229_TaggedContent, TaggedContent as imported232_TaggedContent, TaggedContent as imported231_TaggedContent, taggedContentC as imported233_taggedContentC, TaggedContent as imported230_TaggedContent, taggedContentC as imported226_taggedContentC, taggedContentC as imported235_taggedContentC, TaggedContent as imported234_TaggedContent, TaggedContent as imported227_TaggedContent } from "./taggedContent";
import * as O from "fp-ts/lib/Option";
import { pipe } from "fp-ts/lib/function";
import * as Ord from "fp-ts/lib/Ord";
import { LocalDate } from "@js-joda/core";
import { OptionFromNullableC, optionFromNullable } from "io-ts-types/lib/optionFromNullable";
import { EventC as imported22_EventC, Event as imported21_Event, Event as imported22_Event, eventC as imported20_eventC, eventC as imported21_eventC, EventC as imported21_EventC } from "./event";
import { PageCU as imported14_PageCU, PageCU as imported13_PageCU, PageCU as imported15_PageCU, PageU as imported6_PageU, PageCU as imported12_PageCU, PageU as imported7_PageU } from "../domaintables/pages";
import { RoadShow as imported23_RoadShow, RoadShow as imported24_RoadShow, roadShowC as imported22_roadShowC, RoadShowC as imported24_RoadShowC, RoadShowC as imported23_RoadShowC, roadShowC as imported23_roadShowC } from "./roadshow";
import { projectC as imported36_projectC, projectC as imported37_projectC, ProjectC as imported43_ProjectC, ProjectC as imported44_ProjectC, Project as imported43_Project, Project as imported44_Project } from "./project";
import * as E from "fp-ts/lib/Either";
import { IssuerNews as imported27_IssuerNews, issuerNewsC as imported27_issuerNewsC, IssuerNewsC as imported27_IssuerNewsC, issuerNewsC as imported26_issuerNewsC, IssuerNewsC as imported26_IssuerNewsC, IssuerNews as imported26_IssuerNews } from "./issuerNewsBase";
import { documentWithCategoryC as imported22_documentWithCategoryC, DocumentWithCategoryC as imported23_DocumentWithCategoryC, DocumentWithCategoryC as imported22_DocumentWithCategoryC, DocumentWithCategory as imported23_DocumentWithCategory, documentWithCategoryC as imported23_documentWithCategoryC, DocumentWithCategory as imported22_DocumentWithCategory } from "./document";
import { BondOffering as imported41_BondOffering, bondOfferingC as imported41_bondOfferingC, bondOfferingC as imported40_bondOfferingC, BondOfferingC as imported40_BondOfferingC, BondOffering as imported40_BondOffering, BondOfferingC as imported41_BondOfferingC } from "./bondOfferingBase";
import { rfpC as imported70_rfpC, Rfp as imported73_Rfp, rfpC as imported71_rfpC, Rfp as imported74_Rfp, RfpC as imported73_RfpC, RfpC as imported74_RfpC } from "./rfpBase";

export type FeaturedBondC = t.TypeC<{
  _tag: t.LiteralC<`FeaturedBond`>,
  bond: imported869_WithStatusCU<imported253_WithModInfoC<imported224_TaggedContentC<imported40_BondOfferingC>>>
}>;
export type FeaturedBond = {
  _tag: `FeaturedBond`,
  bond: imported434_WithStatusU<imported253_WithModInfo<imported224_TaggedContent<imported40_BondOffering>>>
};
export const featuredBondC: FeaturedBondC = t.type({
  _tag: t.literal(`FeaturedBond`),
  bond: imported868_WithStatusCU(imported253_withModInfoC(imported224_taggedContentC(imported40_bondOfferingC)))
}) satisfies t.Type<FeaturedBond, unknown>;


export const rfp = {
  _tag: `Rfp`,
  id: 8
} as const;

export type RfpTaggedC = t.TypeC<{
  _tag: t.LiteralC<`Rfp`>
}>;
export const rfpTaggedC: RfpTaggedC = t.type({
  _tag: t.literal(`Rfp`)
});
export type RfpTagged = t.TypeOf<RfpTaggedC>;
export type Rfp = RfpTagged & typeof rfp;
export type RfpC = t.Type<Rfp, RfpTagged>;
export const rfpC: RfpC = pipe(rfpTaggedC, c => new t.Type<Rfp, RfpTagged>(
  `Rfp`,
  (u: unknown): u is Rfp => E.isRight(c.decode(u)),
  (u: unknown): E.Either<t.Errors, Rfp> => pipe(c.decode(u), E.map(x => ({ ...x, ...rfp }))),
  (x: Rfp): RfpTagged => ({ ...x, _tag: `Rfp`}),
)) satisfies t.Type<Rfp, unknown>;


export type FeaturedRfpC = t.TypeC<{
  _tag: t.LiteralC<`FeaturedRfp`>,
  rfp: imported871_WithStatusCU<imported254_WithModInfoC<imported225_TaggedContentC<imported73_RfpC>>>
}>;
export type FeaturedRfp = {
  _tag: `FeaturedRfp`,
  rfp: imported435_WithStatusU<imported254_WithModInfo<imported225_TaggedContent<imported73_Rfp>>>
};
export const featuredRfpC: FeaturedRfpC = t.type({
  _tag: t.literal(`FeaturedRfp`),
  rfp: imported870_WithStatusCU(imported254_withModInfoC(imported225_taggedContentC(imported70_rfpC)))
}) satisfies t.Type<FeaturedRfp, unknown>;


export const news = {
  _tag: `News`,
  id: 3
} as const;

export type NewsTaggedC = t.TypeC<{
  _tag: t.LiteralC<`News`>
}>;
export const newsTaggedC: NewsTaggedC = t.type({
  _tag: t.literal(`News`)
});
export type NewsTagged = t.TypeOf<NewsTaggedC>;
export type News = NewsTagged & typeof news;
export type NewsC = t.Type<News, NewsTagged>;
export const newsC: NewsC = pipe(newsTaggedC, c => new t.Type<News, NewsTagged>(
  `News`,
  (u: unknown): u is News => E.isRight(c.decode(u)),
  (u: unknown): E.Either<t.Errors, News> => pipe(c.decode(u), E.map(x => ({ ...x, ...news }))),
  (x: News): NewsTagged => ({ ...x, _tag: `News`}),
)) satisfies t.Type<News, unknown>;


export type FeaturedNewsC = t.TypeC<{
  _tag: t.LiteralC<`FeaturedNews`>,
  news: imported873_WithStatusCU<imported255_WithModInfoC<imported226_TaggedContentC<imported26_IssuerNewsC>>>
}>;
export type FeaturedNews = {
  _tag: `FeaturedNews`,
  news: imported436_WithStatusU<imported255_WithModInfo<imported226_TaggedContent<imported26_IssuerNews>>>
};
export const featuredNewsC: FeaturedNewsC = t.type({
  _tag: t.literal(`FeaturedNews`),
  news: imported872_WithStatusCU(imported255_withModInfoC(imported226_taggedContentC(imported26_issuerNewsC)))
}) satisfies t.Type<FeaturedNews, unknown>;


export const event = {
  _tag: `Event`,
  id: 2
} as const;

export type EventTaggedC = t.TypeC<{
  _tag: t.LiteralC<`Event`>
}>;
export const eventTaggedC: EventTaggedC = t.type({
  _tag: t.literal(`Event`)
});
export type EventTagged = t.TypeOf<EventTaggedC>;
export type Event = EventTagged & typeof event;
export type EventC = t.Type<Event, EventTagged>;
export const eventC: EventC = pipe(eventTaggedC, c => new t.Type<Event, EventTagged>(
  `Event`,
  (u: unknown): u is Event => E.isRight(c.decode(u)),
  (u: unknown): E.Either<t.Errors, Event> => pipe(c.decode(u), E.map(x => ({ ...x, ...event }))),
  (x: Event): EventTagged => ({ ...x, _tag: `Event`}),
)) satisfies t.Type<Event, unknown>;


export type FeaturedEventC = t.TypeC<{
  _tag: t.LiteralC<`FeaturedEvent`>,
  event: imported875_WithStatusCU<imported256_WithModInfoC<imported21_EventC>>
}>;
export type FeaturedEvent = {
  _tag: `FeaturedEvent`,
  event: imported437_WithStatusU<imported256_WithModInfo<imported21_Event>>
};
export const featuredEventC: FeaturedEventC = t.type({
  _tag: t.literal(`FeaturedEvent`),
  event: imported874_WithStatusCU(imported256_withModInfoC(imported20_eventC))
}) satisfies t.Type<FeaturedEvent, unknown>;


export const document = {
  _tag: `Document`,
  id: 1
} as const;

export type DocumentTaggedC = t.TypeC<{
  _tag: t.LiteralC<`Document`>
}>;
export const documentTaggedC: DocumentTaggedC = t.type({
  _tag: t.literal(`Document`)
});
export type DocumentTagged = t.TypeOf<DocumentTaggedC>;
export type Document = DocumentTagged & typeof document;
export type DocumentC = t.Type<Document, DocumentTagged>;
export const documentC: DocumentC = pipe(documentTaggedC, c => new t.Type<Document, DocumentTagged>(
  `Document`,
  (u: unknown): u is Document => E.isRight(c.decode(u)),
  (u: unknown): E.Either<t.Errors, Document> => pipe(c.decode(u), E.map(x => ({ ...x, ...document }))),
  (x: Document): DocumentTagged => ({ ...x, _tag: `Document`}),
)) satisfies t.Type<Document, unknown>;


export type FeaturedDocumentC = t.TypeC<{
  _tag: t.LiteralC<`FeaturedDocument`>,
  document: imported877_WithStatusCU<imported257_WithModInfoC<imported227_TaggedContentC<imported22_DocumentWithCategoryC>>>
}>;
export type FeaturedDocument = {
  _tag: `FeaturedDocument`,
  document: imported438_WithStatusU<imported257_WithModInfo<imported227_TaggedContent<imported22_DocumentWithCategory>>>
};
export const featuredDocumentC: FeaturedDocumentC = t.type({
  _tag: t.literal(`FeaturedDocument`),
  document: imported876_WithStatusCU(imported257_withModInfoC(imported227_taggedContentC(imported22_documentWithCategoryC)))
}) satisfies t.Type<FeaturedDocument, unknown>;


export const project = {
  _tag: `Project`,
  id: 6
} as const;

export type ProjectTaggedC = t.TypeC<{
  _tag: t.LiteralC<`Project`>
}>;
export const projectTaggedC: ProjectTaggedC = t.type({
  _tag: t.literal(`Project`)
});
export type ProjectTagged = t.TypeOf<ProjectTaggedC>;
export type Project = ProjectTagged & typeof project;
export type ProjectC = t.Type<Project, ProjectTagged>;
export const projectC: ProjectC = pipe(projectTaggedC, c => new t.Type<Project, ProjectTagged>(
  `Project`,
  (u: unknown): u is Project => E.isRight(c.decode(u)),
  (u: unknown): E.Either<t.Errors, Project> => pipe(c.decode(u), E.map(x => ({ ...x, ...project }))),
  (x: Project): ProjectTagged => ({ ...x, _tag: `Project`}),
)) satisfies t.Type<Project, unknown>;


export type FeaturedProjectC = t.TypeC<{
  _tag: t.LiteralC<`FeaturedProject`>,
  project: imported879_WithStatusCU<imported258_WithModInfoC<imported228_TaggedContentC<imported43_ProjectC>>>
}>;
export type FeaturedProject = {
  _tag: `FeaturedProject`,
  project: imported439_WithStatusU<imported258_WithModInfo<imported228_TaggedContent<imported43_Project>>>
};
export const featuredProjectC: FeaturedProjectC = t.type({
  _tag: t.literal(`FeaturedProject`),
  project: imported878_WithStatusCU(imported258_withModInfoC(imported228_taggedContentC(imported36_projectC)))
}) satisfies t.Type<FeaturedProject, unknown>;


export const roadShow = {
  _tag: `RoadShow`,
  id: 7
} as const;

export type RoadShowTaggedC = t.TypeC<{
  _tag: t.LiteralC<`RoadShow`>
}>;
export const roadShowTaggedC: RoadShowTaggedC = t.type({
  _tag: t.literal(`RoadShow`)
});
export type RoadShowTagged = t.TypeOf<RoadShowTaggedC>;
export type RoadShow = RoadShowTagged & typeof roadShow;
export type RoadShowC = t.Type<RoadShow, RoadShowTagged>;
export const roadShowC: RoadShowC = pipe(roadShowTaggedC, c => new t.Type<RoadShow, RoadShowTagged>(
  `RoadShow`,
  (u: unknown): u is RoadShow => E.isRight(c.decode(u)),
  (u: unknown): E.Either<t.Errors, RoadShow> => pipe(c.decode(u), E.map(x => ({ ...x, ...roadShow }))),
  (x: RoadShow): RoadShowTagged => ({ ...x, _tag: `RoadShow`}),
)) satisfies t.Type<RoadShow, unknown>;


export type FeaturedRoadshowC = t.TypeC<{
  _tag: t.LiteralC<`FeaturedRoadshow`>,
  roadshow: imported292_WithIdC<imported259_WithModInfoC<imported229_TaggedContentC<imported23_RoadShowC>>>
}>;
export type FeaturedRoadshow = {
  _tag: `FeaturedRoadshow`,
  roadshow: imported292_WithId<imported259_WithModInfo<imported229_TaggedContent<imported23_RoadShow>>>
};
export const featuredRoadshowC: FeaturedRoadshowC = t.type({
  _tag: t.literal(`FeaturedRoadshow`),
  roadshow: imported292_withIdC(imported259_withModInfoC(imported229_taggedContentC(imported22_roadShowC)))
}) satisfies t.Type<FeaturedRoadshow, unknown>;


export const page = {
  _tag: `Page`,
  id: 5
} as const;

export type PageTaggedC = t.TypeC<{
  _tag: t.LiteralC<`Page`>
}>;
export const pageTaggedC: PageTaggedC = t.type({
  _tag: t.literal(`Page`)
});
export type PageTagged = t.TypeOf<PageTaggedC>;
export type Page = PageTagged & typeof page;
export type PageC = t.Type<Page, PageTagged>;
export const pageC: PageC = pipe(pageTaggedC, c => new t.Type<Page, PageTagged>(
  `Page`,
  (u: unknown): u is Page => E.isRight(c.decode(u)),
  (u: unknown): E.Either<t.Errors, Page> => pipe(c.decode(u), E.map(x => ({ ...x, ...page }))),
  (x: Page): PageTagged => ({ ...x, _tag: `Page`}),
)) satisfies t.Type<Page, unknown>;


export type FeaturedPageC = t.TypeC<{
  _tag: t.LiteralC<`FeaturedPage`>,
  page: imported13_PageCU,
  header: t.StringC
}>;
export type FeaturedPage = {
  _tag: `FeaturedPage`,
  page: imported6_PageU,
  header: string
};
export const featuredPageC: FeaturedPageC = t.type({
  _tag: t.literal(`FeaturedPage`),
  page: imported12_PageCU,
  header: t.string
}) satisfies t.Type<FeaturedPage, unknown>;


export const allFeaturedItemC = [featuredBondC, featuredRfpC, featuredNewsC, featuredEventC, featuredDocumentC, featuredProjectC, featuredRoadshowC, featuredPageC] as const;
export const allFeaturedItemNames = [`FeaturedBond`, `FeaturedRfp`, `FeaturedNews`, `FeaturedEvent`, `FeaturedDocument`, `FeaturedProject`, `FeaturedRoadshow`, `FeaturedPage`] as const;
export type FeaturedItemName = (typeof allFeaturedItemNames)[number];

export type FeaturedItemCU = t.UnionC<[FeaturedBondC, FeaturedRfpC, FeaturedNewsC, FeaturedEventC, FeaturedDocumentC, FeaturedProjectC, FeaturedRoadshowC, FeaturedPageC]>;
export type FeaturedItemU = FeaturedBond | FeaturedRfp | FeaturedNews | FeaturedEvent | FeaturedDocument | FeaturedProject | FeaturedRoadshow | FeaturedPage;
export const FeaturedItemCU: FeaturedItemCU = t.union([featuredBondC, featuredRfpC, featuredNewsC, featuredEventC, featuredDocumentC, featuredProjectC, featuredRoadshowC, featuredPageC]) satisfies t.Type<FeaturedItemU, unknown>;

export type FeaturedItemMap<A> = { [K in FeaturedItemName]: A };


export type FeaturedItemWithMetaC = t.TypeC<{
  item: FeaturedItemCU,
  displayUntil: OptionFromNullableC<LocalDateC>,
  sortOrder: t.NumberC
}>;
export type FeaturedItemWithMeta = {
  item: FeaturedItemU,
  displayUntil: O.Option<LocalDate>,
  sortOrder: number
};
export const featuredItemWithMetaC: FeaturedItemWithMetaC = t.type({
  item: FeaturedItemCU,
  displayUntil: optionFromNullable(LocalDateC),
  sortOrder: t.number
}) satisfies t.Type<FeaturedItemWithMeta, unknown>;


export type FeaturedItemsAvailableC = t.TypeC<{
  bonds: t.ReadonlyArrayC<imported886_WithStatusCU<imported230_TaggedContentC<imported41_BondOfferingC>>>,
  rfps: t.ReadonlyArrayC<imported887_WithStatusCU<imported231_TaggedContentC<imported74_RfpC>>>,
  news: t.ReadonlyArrayC<imported888_WithStatusCU<imported232_TaggedContentC<imported27_IssuerNewsC>>>,
  events: t.ReadonlyArrayC<imported889_WithStatusCU<imported22_EventC>>,
  documents: t.ReadonlyArrayC<imported890_WithStatusCU<imported233_TaggedContentC<imported23_DocumentWithCategoryC>>>,
  projects: t.ReadonlyArrayC<imported891_WithStatusCU<imported234_TaggedContentC<imported44_ProjectC>>>,
  roadshows: t.ReadonlyArrayC<imported293_WithIdC<imported235_TaggedContentC<imported24_RoadShowC>>>,
  pages: t.ReadonlyArrayC<imported15_PageCU>
}>;
export type FeaturedItemsAvailable = {
  bonds: ReadonlyArray<imported440_WithStatusU<imported230_TaggedContent<imported41_BondOffering>>>,
  rfps: ReadonlyArray<imported441_WithStatusU<imported231_TaggedContent<imported74_Rfp>>>,
  news: ReadonlyArray<imported442_WithStatusU<imported232_TaggedContent<imported27_IssuerNews>>>,
  events: ReadonlyArray<imported443_WithStatusU<imported22_Event>>,
  documents: ReadonlyArray<imported444_WithStatusU<imported233_TaggedContent<imported23_DocumentWithCategory>>>,
  projects: ReadonlyArray<imported445_WithStatusU<imported234_TaggedContent<imported44_Project>>>,
  roadshows: ReadonlyArray<imported293_WithId<imported235_TaggedContent<imported24_RoadShow>>>,
  pages: ReadonlyArray<imported7_PageU>
};
export const featuredItemsAvailableC: FeaturedItemsAvailableC = t.type({
  bonds: t.readonlyArray(imported880_WithStatusCU(imported230_taggedContentC(imported41_bondOfferingC))),
  rfps: t.readonlyArray(imported881_WithStatusCU(imported231_taggedContentC(imported71_rfpC))),
  news: t.readonlyArray(imported882_WithStatusCU(imported232_taggedContentC(imported27_issuerNewsC))),
  events: t.readonlyArray(imported883_WithStatusCU(imported21_eventC)),
  documents: t.readonlyArray(imported884_WithStatusCU(imported233_taggedContentC(imported23_documentWithCategoryC))),
  projects: t.readonlyArray(imported885_WithStatusCU(imported234_taggedContentC(imported37_projectC))),
  roadshows: t.readonlyArray(imported293_withIdC(imported235_taggedContentC(imported23_roadShowC))),
  pages: t.readonlyArray(imported14_PageCU)
}) satisfies t.Type<FeaturedItemsAvailable, unknown>;


export type FeaturedItemPostBodyC = t.TypeC<{
  id: t.NumberC,
  itemId: t.NumberC,
  itemTypeId: t.NumberC,
  header: OptionFromNullableC<t.StringC>,
  displayUntil: OptionFromNullableC<LocalDateC>,
  sortOrder: t.NumberC
}>;
export type FeaturedItemPostBody = {
  id: number,
  itemId: number,
  itemTypeId: number,
  header: O.Option<string>,
  displayUntil: O.Option<LocalDate>,
  sortOrder: number
};
export const featuredItemPostBodyC: FeaturedItemPostBodyC = t.type({
  id: t.number,
  itemId: t.number,
  itemTypeId: t.number,
  header: optionFromNullable(t.string),
  displayUntil: optionFromNullable(LocalDateC),
  sortOrder: t.number
}) satisfies t.Type<FeaturedItemPostBody, unknown>;


export const offering = {
  _tag: `Offering`,
  id: 4
} as const;

export type OfferingTaggedC = t.TypeC<{
  _tag: t.LiteralC<`Offering`>
}>;
export const offeringTaggedC: OfferingTaggedC = t.type({
  _tag: t.literal(`Offering`)
});
export type OfferingTagged = t.TypeOf<OfferingTaggedC>;
export type Offering = OfferingTagged & typeof offering;
export type OfferingC = t.Type<Offering, OfferingTagged>;
export const offeringC: OfferingC = pipe(offeringTaggedC, c => new t.Type<Offering, OfferingTagged>(
  `Offering`,
  (u: unknown): u is Offering => E.isRight(c.decode(u)),
  (u: unknown): E.Either<t.Errors, Offering> => pipe(c.decode(u), E.map(x => ({ ...x, ...offering }))),
  (x: Offering): OfferingTagged => ({ ...x, _tag: `Offering`}),
)) satisfies t.Type<Offering, unknown>;


export const allFeaturedItemTypeC = [documentC, eventC, newsC, offeringC, pageC, projectC, roadShowC, rfpC] as const;
export const allFeaturedItemTypeNames = [`Document`, `Event`, `News`, `Offering`, `Page`, `Project`, `RoadShow`, `Rfp`] as const;
export type FeaturedItemTypeName = (typeof allFeaturedItemTypeNames)[number];

export type FeaturedItemTypeCU = t.UnionC<[DocumentC, EventC, NewsC, OfferingC, PageC, ProjectC, RoadShowC, RfpC]>;
export type FeaturedItemTypeU = Document | Event | News | Offering | Page | Project | RoadShow | Rfp;
export const FeaturedItemTypeCU: FeaturedItemTypeCU = t.union([documentC, eventC, newsC, offeringC, pageC, projectC, roadShowC, rfpC]) satisfies t.Type<FeaturedItemTypeU, unknown>;

export const featuredItemTypeOrd: Ord.Ord<FeaturedItemTypeU> = pipe(stringOrd, Ord.contramap(x => x._tag));
export const allFeaturedItemType = [document, event, news, offering, page, project, roadShow, rfp] as const;
export type FeaturedItemTypeMap<A> = { [K in FeaturedItemTypeName]: A };


